// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__sLYtF","options":"AnswerScale_options__1YbkG","selected":"AnswerScale_selected__CJOHG"};